import { IComboBox, IComboBoxOption } from "@fluentui/react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import personaServicio from "../../services/persona/personaServicio";

interface IComboBoxOptionPersonalizado {
  key: string;
  text: string;
  puesto: string;
}
export const useComboSupervisores = () => {
  const controllerRef = useRef<AbortController>(new AbortController());

  const [SupervisoresCombo, setSupervisoresCombo] = useState<
    IComboBoxOptionPersonalizado[]
  >([]);
  const [search, setSearch] = useState("");

  const comboBoxRefSupervisores = useRef<IComboBox>(null);

  const _openOptionSupervisores = useCallback(
    () => comboBoxRefSupervisores.current?.focus(true),
    []
  );
  const onClickComboSupevisores = () =>
    comboBoxRefSupervisores.current?.focus(true);

  const _onkeyUpSearchSupervisores = (
    event: React.KeyboardEvent<IComboBox>
  ) => {
    if (event.code === "Escape") {
      comboBoxRefSupervisores.current?.focus(false);
      setSearch("");
    } else {
      _openOptionSupervisores();
      let { value } = event?.target as HTMLInputElement;
      setSearch(value);
    }
  };
  const getComboSupervisores = () => {
    controllerRef.current.abort();
    const newController = new AbortController();
    controllerRef.current = newController;

    personaServicio.getSupervisoresCombo(search, newController).then((res) => {
      if (res.status === 200) {
        setSupervisoresCombo(res.data);
      }
    }).catch((error) => {
      console.error("Error fetching Supervisores Combo:", error);
    });
  };

  const obtenerPuesto = (key:any) => {
    const puestos = SupervisoresCombo?.find((elem) => elem.key === key);
    return puestos ? puestos.puesto : "No Tiene Puesto";
  };

  const limpiarFilters = () => {
    setSearch("");
  }

  useEffect(() => {
    getComboSupervisores();
  }, [search]);

  return {
    obtenerPuesto,
    search,
    setSearch,
    comboBoxRefSupervisores,
    SupervisoresCombo,
    onClickComboSupevisores,
    _onkeyUpSearchSupervisores,
    getComboSupervisores,
    limpiarFilters
  };
};
